/*
 * @Author: zhoue 627691214@qq.com
 * @Date: 2022-07-25 14:09:59
 * @LastEditors: zhoue 627691214@qq.com
 * @LastEditTime: 2024-06-14 15:06:55
 * @FilePath: /cabinet-front/src/plugins/alert.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { MessageBox } from "element-ui";

export default (alert = {
  //删除操作弹出
  deleteAlert() {
    return MessageBox.confirm("确定要执行删除操作?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  },
   //投放广告弹窗确定
   advertAlert() {
    return MessageBox.confirm("确定要投放广告?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  },
   //下线广告投放
   offlineAlert() {
    return MessageBox.confirm("确定要下线广告投放?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  },
     //强制下线
     offlineAlertDown() {
      return MessageBox.confirm("确定要下线吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
    },
  alert(msg) {
    return MessageBox.confirm(msg, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  },
    restockAlert(msg) {
    return MessageBox.confirm("确定要执行此操作吗","提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  },
      kcAlert(msg) {
    return MessageBox.confirm("完全删除当前库存，并恢复移机前库存","提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  }
});
